import { render } from "./TrabajosRealizadosProveedor.vue?vue&type=template&id=25be2b92&scoped=true"
import script from "./TrabajosRealizadosProveedor.vue?vue&type=script&lang=js"
export * from "./TrabajosRealizadosProveedor.vue?vue&type=script&lang=js"

import "./TrabajosRealizadosProveedor.vue?vue&type=style&index=0&id=25be2b92&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25be2b92"]])

export default __exports__